<style lang="stylus">
.mobileHeader {
  background-color: #5a6063;
  width: 100%;
  color: white;
  padding: 7px 0px 7px 26px;
  font-weight: 600;
}
</style>

<template>
  <div class="mobileHeader" v-if="welcomeTitle">
    <strong>{{ welcomeTitle }}</strong>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useUserStore } from '@/stores/user';

export default defineComponent({
  computed: {
    welcomeTitle() {
      const userStore = useUserStore();
      return userStore.welcomePageData.welcomePageTitle;
    }
  }
});
</script>
